module.exports = __webpack_public_path__ + "static/media/star_enabled.18970be9.svg";